import { Component, Input } from '@angular/core';
import { InstructionsDialogComponent } from './components/instructions-dialog/instructions-dialog.component';
import { MatDialog } from '@angular/material/dialog';

@Component({
  selector: 'common-collection-instructions',
  templateUrl: './collection-instructions.component.html',
  styleUrls: ['./collection-instructions.component.scss'],
})
export class CollectionInstructionsComponent {
  @Input() brandColor!: string;
  @Input() textColor!: string;
  @Input() labelUrl?: string;
  @Input() deliveryPartner?: string;

  constructor(public dialog: MatDialog) {}

  openCollectionInstructions() {
    this.dialog.open(InstructionsDialogComponent, {
      width: '100%',
      maxWidth: '48rem',
      panelClass: 'instructions-dialog-container',
      data: {
        brandColor: this.brandColor,
        textColor: this.textColor,
        labelUrl: this.labelUrl,
        deliveryPartner: this.deliveryPartner,
      },
    });
  }
}
